import type { TenantConfig } from '@/types/TenantConfig'

const navy = '#111835'

export const thfc: TenantConfig = {
  logo: 'assets/thfc/static/logo.svg',
  themeOptions: {
    primaryColor: '#3DB7E4',
    secondaryColor: '#618495',
    logoHeight: '79px',
    headerBackground: navy,
    headerHeight: '110px',
    footerBackgroundColor: navy,
    footerTextColor: 'white',
    cartHeaderBackgroundColor: navy,
    memberLinksColor: 'white',
    memberLinksColorHover: 'white',
    mobileFooter: {
      backgroundColor: navy,
      textColor: '#A1A8AF',
      cartButtonBackgroundColor: navy,
      cartButtonHoverBackgroundColor: navy,
      cartButtonBorder: '2px solid #37394B',
      cartButtonIconColor: '#FFFFFF',
      priceTextColor: '#E0E3E5',
    },
    dialog: {
      headerTextColor: '#FFFFFF',
      headerBackground: navy,
      headerIconColor: '#3DB7E4',
    },
  },
  componentOptions: {
    stripeCreditCard: {
      fontFaceStylesheet: 'https://use.typekit.net/tsu4pxd.css',
    },
    completedOrdersRoute: {
      completedImage: {
        desktop: 'assets/thfc/static/completed.jpeg',
      },
      completedContentOffset: {
        desktop: '-300px',
        mobile: '-150px',
      },
    },
  },
  i18nOverrides: {
    en: {
      applyGiftCards: {
        modalTitle: 'Apply a Gift Voucher',
        applyGiftCard: 'Apply a gift voucher',
        applyAnotherGiftCard: 'Apply another gift voucher',
        giftCardNotFound: 'Gift voucher not found',
      },
      applyGiftCardsModal: {
        giftCardNumberLabel: 'Gift Voucher Number',
      },
    },
  },
}
